import { useRPCQuery } from "eddev/hooks"
import { useIsSSR } from "eddev/routing"
import { useMemo } from "react"
import { EventStatus } from "../types.graphql"

export function useEventManifest() {
  const result = useRPCQuery("api.ticketing.ticketManifest", undefined, {
    structuralSharing: true,
    staleTime: 1000 * 60 * 1,
  })

  return result
}

export function useEventStatus(filmOrSessionId: string) {
  const manifest = useEventManifest()
  const hydrating = useIsSSR()

  const result = useMemo(() => {
    const film = manifest.data?.films.find(
      (film) => film.id === filmOrSessionId || film.sessions.some((s) => s.id === filmOrSessionId),
    )
    const session = film?.sessions.find((s) => s.id === filmOrSessionId)
    if (session) {
      return {
        session,
        film,
        status: session.status,
      }
    } else if (film) {
      let status: EventStatus = EventStatus.Normal
      if (film.sessions.length === 1) {
        status = film.sessions[0].status
      } else if (film.sessions.length > 1) {
        if (film.sessions.every((s) => s.status === EventStatus.SoldOut)) {
          status = EventStatus.SoldOut
        } else if (
          film.sessions.some((s) => s.status === EventStatus.SoldOut || s.status === EventStatus.SellingFast)
        ) {
          status = EventStatus.SellingFast
        }
      }
      return {
        film,
        // TODO: Status should be calculated from all films here
        status: status,
      }
    }
  }, [manifest.data, filmOrSessionId])

  return hydrating ? null : result
}
